/**
 *
 * DocumentsOverview
 *
 */

import React from 'react';
import { GetValidatableInvoiceContainersResponse } from 'lib/api/invoiceContainers';

// parts
import { DocumentsOverviewThumb } from './DocumentsOverviewThumb';
import {  DocumentsOverviewColumn } from './DocumentsOverviewColumn';

// decorate
import { decorate, Decorate } from './decorate';

export interface DocumentsOverviewProps {
  documents: GetValidatableInvoiceContainersResponse;
  sizeFactor?: number;
  isColumnView: boolean;
  selectDocument: (containerId: string, invoiceId: string) => any;
  selectedDocuments: object[];
  canSelectDocuments: boolean;
}

const isDocumentSelected = (containerId: string, selectedDocuments: object[]) => {
  let selected = false;
  selectedDocuments.map((selectedDocument: any) => {
    if (selectedDocument.ContainerId === containerId) {
      selected = true;
    }
  });
  return selected;
}

const DocumentsOverview: React.FC<DocumentsOverviewProps & Decorate> = (props) => {
  
  const { classes, documents, sizeFactor = 1, isColumnView, selectDocument, selectedDocuments, canSelectDocuments } = props;
  
  return (
    <>
      {isColumnView && documents.InvoiceContainers.map((document) => (
        <tbody className={classes.root}>
          <DocumentsOverviewColumn
            key={document.ContainerId}
            document={document}
            sizeFactor={sizeFactor}
          />
        </tbody>
      ))}
      {!isColumnView && documents.InvoiceContainers.map((document) => (
          <DocumentsOverviewThumb
            key={document.ContainerId}
            document={document}
            sizeFactor={sizeFactor}
            selectDocument={selectDocument}
            isSelected={isDocumentSelected(document.ContainerId, selectedDocuments)}
            showSelectCheckbox={canSelectDocuments}
          />
       ))}
    </>
  );
};

const StyledDocumentsOverview = decorate(DocumentsOverview);
export { StyledDocumentsOverview as DocumentsOverview };
